import React from 'react';
import {NavLink} from 'react-router-dom';
import './styles.css';

type Props = {
  +merchant_id: number | null
};

const DevSidebar = ({merchant_id}: Props) => {
  const LINKS = [
    {
      title: 'Disputes (old)',
      path: `/${merchant_id}/support/disputes`
    },
    {
      title: 'Chargeback registry',
      path: `/${merchant_id}/analytics/main-info/afs/chargeback-registry`
    }
  ];

  return (
    <div className="dev-sidebar">
      {LINKS.map(({title, path}) => (
        <NavLink className="dev-sidebar__link" activeClassName="active" key={title} to={path}>
          {title}
        </NavLink>
      ))}
    </div>
  );
};

export default DevSidebar;
